module.exports = __webpack_public_path__ + "static/img/ve.b2cd5a9a.svg";